import { useState, useEffect } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";


const TopicInput = (({ numberDefault, submitTopic, liveGame }) => {
    const [topic, setTopic] = useState('');
    const [level, setLevel] = useState('');
    const [number, setNumber] = useState(numberDefault);

    useEffect(() => {
        if (numberDefault) setNumber(numberDefault);
    }, [numberDefault])

    const submitParams = () => {
        if (topic === '') {
            window.alert('You must enter a topic');
            return;
        }
        if (level === '') {
            window.alert('You must enter a level');
            return;
        }
        if (!Number.isInteger(number) || number <=0 || number > 25) {
            window.alert('You must enter a number between 1-25');
            return;
        }

        submitTopic(topic, level, number);
    }

    return (
    <Form onSubmit={(e) => {
        e.preventDefault();  
        submitParams();
    }}>

        <Row className="mb-3">
        <Col xl={1}></Col>
        <Col md={12} lg={4}>
            <Form.Group>
            <Form.Label className="d-block mx-auto text-center fw-bold">Enter subject - any subject</Form.Label>
            <Form.Control
                type="text"
                id="topic"
                placeholder="Enter topic"
                value={topic}
                onChange={(e) => setTopic(e.target.value)}
                className="mx-auto border-2 border-secondary"
                style={{ maxWidth: "350px" }}
            />
            </Form.Group>
        </Col>

        <Col md={12} lg={4} xl={3}>
            <Form.Group>
            <Form.Label className="d-block mx-auto text-center fw-bold">Challenge yourself</Form.Label>
            <Form.Select
                id="level"
                value={level}
                onChange={(e) => setLevel(e.target.value)}
                className="mx-auto text-center border-2 border-secondary"
                style={{ maxWidth: "250px" }}
            >
                <option value="">Select Difficulty</option>
                <option value="elementary">Elementary</option>
                <option value="high_school">High School</option>
                <option value="honors">Honors</option>
                <option value="university">University</option>
            </Form.Select>
            </Form.Group>
        </Col>

        <Col md={12} lg={4} xl={3}>
            <Form.Group>
            <Form.Label className="d-block mx-auto text-center fw-bold">Number of Questions (max 25)</Form.Label>
            <Form.Control
                type="number"
                id="number"
                placeholder="Number of questions"
                value={number}
                onChange={(e) => setNumber(e.target.valueAsNumber)}
                onFocus={(e) => e.target.select()}
                min={1}
                max={25}
                className="mx-auto text-center border-2 border-secondary"
                style={{ maxWidth: "80px" }}
            />
            </Form.Group>
        </Col>
        <Col xl={1}></Col>
        </Row>

        <div className="text-center mt-4">
        <Button
            id="submit-btn"
            className="quiz-btn mx-0"
            type="submit"
        >
            {liveGame ? 'Submit Topic' : 'Generate Quiz'}
        </Button>
        </div>
    </Form>
    );
})

export default TopicInput